var map = {
	"./1.png": "aa2b",
	"./2.png": "c67d",
	"./21.png": "a54e",
	"./22.png": "00e5",
	"./23.png": "3e8d",
	"./24.png": "a7dc",
	"./3.png": "acbd",
	"./roof-01.png": "9523",
	"./train-02.png": "79c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a98";